import React, { useMemo, useState } from 'react';
import { Form, Button, Input, Spin, notification } from 'antd';

import { ReactSVG } from 'react-svg';

import { useWatch } from 'antd/es/form/Form';

export const SetupDeliveryMatch = ({ done, existing }) => {
  const [form] = Form.useForm();

  const [isSaving, setIsSaving] = useState(false);

  const handleCancel = () => {
    done(form.getFieldsValue(['API_KEY', 'CLIENT']));
  };

  const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const submit = async (values) => {
    setIsSaving(true);
    // construct param objects from input
    await wait(500);
    setIsSaving(false);
    notification.success({ message: 'Saved Delivery Match settings' });
    done(values);
  };

  const api = useWatch('API_KEY', form);
  const secret = useWatch('CLIENT', form);
  const disabled = useMemo(() => !api || !secret, [api, secret]);

  return (
    <Spin spinning={false}>
      <div className="RoutePlanForm">
        <Form form={form} scrollToFirstError onFinish={submit} layout="vertical">
          <h4>DeliveryMatch settings</h4>
          <Form.Item label="Client" name="CLIENT" initialValue={existing.CLIENT}>
            <Input style={{ maxWidth: 300 }} />
          </Form.Item>

          <Form.Item label="API key" name="API_KEY" initialValue={existing.API_KEY}>
            <Input style={{ maxWidth: 300 }} />
          </Form.Item>

          <div className="FormFooter">
            <Button key="cancel" size="small" onClick={handleCancel}>
              Cancel
            </Button>

            <Button key="confirm" type="primary" size="small" htmlType="submit" disabled={disabled} loading={isSaving}>
              Update DeliveryMatch integration
              <ReactSVG className="icon" src="/icons/done.svg" />
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};
